import { render, staticRenderFns } from "./SearchAppVersion.vue?vue&type=template&id=29418dc1&scoped=true&"
import script from "./SearchAppVersion.vue?vue&type=script&lang=js&"
export * from "./SearchAppVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29418dc1",
  null
  
)

export default component.exports